import React from 'react';
import { ReactConversation } from '@indeed/messaging-react';

interface ConversationContainerProps {
    conversationId: string;
    renderBeforeListComponents?: React.ReactNode[];
    navigationHandlers?: {
        onBackClick?: () => void;
        onNavigateToJobDetails?: () => void;
    };
}

const ConversationContainer: React.FC<ConversationContainerProps> = ({
    conversationId,
    renderBeforeListComponents,
    navigationHandlers,
}) => {
    return (
        <ReactConversation
            conversationId={conversationId}
            renderBeforeListComponents={renderBeforeListComponents}
            navigationHandlers={navigationHandlers}
        />
    );
};

export default ConversationContainer;
